export const Plans = {
  ONLINE_CONSULTATION: 'Online Consultation',
  READY_TO_SHIP: 'Ready to Ship',
};
